import Button from 'tailwind-components/Button/Button';
import Input from 'tailwind-components/Input/Input';
import React, { useRef } from 'react';
import propTypes from 'prop-types';
import { Copy } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { showAlert } from 'state/actions/site';

function InputWithCopyButton({
  noSpacing,
  fixedWidth,
  labelClassName,
  value,
  ...inputProps
}) {
  const input = useRef(null);
  const dispatch = useDispatch();

  const copyText = () => {
    const text = input?.current?.value ?? value ?? '';
    navigator.clipboard.writeText(text);
    dispatch(showAlert({ message: 'Copied to clipboard!', code: 'success' }));
  };

  const hasValue = (value ?? '').toString().trim() !== '';

  return (
    <div className='flex flex-row items-center gap-2'>
      <Input
        ref={input}
        value={value}
        {...inputProps}
        noSpacing={noSpacing}
        fixedWidth={fixedWidth}
        labelClassName={labelClassName}
      />
      <Button
        size='xsmall'
        variant='secondary'
        outlined
        text={'Copy'}
        icon={<Copy className='size-inherit' strokeWidth={2} />}
        onClick={copyText}
        isDisabled={!hasValue}
      />
    </div>
  );
}

InputWithCopyButton.propTypes = {
  className: propTypes.string,
  noSpacing: propTypes.bool,
  fixedWidth: propTypes.bool,
  labelClassName: propTypes.string,
  value: propTypes.string
};

export default InputWithCopyButton;
